import React from 'react';
import { FormControl, Select, MenuItem, Typography, CircularProgress, Box } from '@mui/material';
import { Business as OrgIcon } from '@mui/icons-material';
import { useOrganization } from '../../contexts/OrganizationContext';

const OrganizationSwitcher = () => {
  const { organizations, selectedOrganization, selectOrganization, loading } = useOrganization();

  const handleChange = (event) => {
    selectOrganization(event.target.value);
  };

  if (loading && organizations.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (organizations.length === 0) {
    return (
      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', py: 1 }}>
        No organizations
      </Typography>
    );
  }

  return (
    <FormControl fullWidth size="small">
      <Select
        value={selectedOrganization?.id || ''}
        onChange={handleChange}
        startAdornment={<OrgIcon sx={{ mr: 1, fontSize: 20, color: '#697079' }} />}
        sx={{
          bgcolor: '#fff',
          fontSize: '13.5px',
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: 'divider'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#9AA1AA'
          },
          '.MuiSvgIcon-root': {
            color: '#697079'
          }
        }}
      >
        {organizations.map((org) => (
          <MenuItem key={org.id} value={org.id}>
            {org.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default OrganizationSwitcher;
